import React from "react";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const DistributerMasterFilter = (props) => {
  const {
    companyName,
    assignedEngineer,
    setCompanyName,
    type,
    statusOptions,
    ClearFilter,
    ApplyFilter,
    status,
    distributorFilter,
    companyList,
    handleLabelFilterChange,
    setAssignedEngineer,
    assignedEngineerList,
    distributorTypeList,
    setType,
    setStatus,
  } = props;

  return (
    <>
      <div
        className="modal fade drawer right-align"
        id="filterRightSideModalPopup"
        tabindex="-1"
        role="dialog"
        aria-labelledby="filterRightSideModalPopupLabel"
      >
        <div className="modal-dialog modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <i className="fas fa-filter"></i>
              <h5 className="modal-title">Filters</h5>
              <i className="fas fa-times" data-dismiss="modal"></i>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="mt-2">
                    <label>Company</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_COMPANY}
                      pageName="DistributorList"
                      dpDownName="company"
                      stateData={companyList}
                      controlName="companyName"
                      handleChange={(e) => {
                        handleLabelFilterChange(e, "companyName");
                      }}
                      valueId={distributorFilter?.companyName}
                      value={companyName}
                      setState={setCompanyName}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Assigned Engineer</label>

                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_ASSIGNED}
                      pageName="DistributorList"
                      dpDownName="salesengineer"
                      stateData={assignedEngineerList}
                      controlName="assignedEngineerName"
                      handleChange={(e) => {
                        handleLabelFilterChange(e, "assignedEngineerName");
                      }}
                      valueId={distributorFilter?.assignedEngineerName}
                      value={assignedEngineer}
                      setState={setAssignedEngineer}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Distributor Type</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_DISTRIBUTOR_TYPE}
                      pageName="DistributorList"
                      dpDownName="distributorTypesdrp"
                      stateData={distributorTypeList}
                      controlName="distributorType"
                      handleChange={(e) => {
                        handleLabelFilterChange(e, "type");
                      }}
                      valueId={distributorFilter?.type}
                      value={type}
                      setState={setType}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Status</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_STATUS}
                      pageName="DistributorList"
                      dpDownName="status"
                      stateData={statusOptions}
                      controlName="Status"
                      handleChange={(e) => {
                        handleLabelFilterChange(e, "status");
                      }}
                      valueId={distributorFilter?.status}
                      value={status}
                      setState={setStatus}
                      checkLabel={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-modal">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn clear-all-btn"
                      data-dismiss="modal"
                      onClick={(e) => ClearFilter()}
                    >
                      Clear all
                    </button>
                    <button
                      type="button"
                      className="btn apply-btn"
                      data-dismiss="modal"
                      onClick={(e) => ApplyFilter()}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DistributerMasterFilter;
